<template>
    <div class="painel-page-inner" style="height: 100%">
        <div class="text-center">
            <h4 style="text-transform: uppercase">{{method.cycle}}</h4>
            <strong v-html="method.title"></strong>
        </div>

        <range-input
            v-if="method.difficulty != 0"
            :min="1"
            :max="3"
            v-model="method.difficulty"
            readonly
            ticks
            :tick-labels="[$t('Baixa'), $t('Média'), $t('Alta')]"
            :tick-colors="['#ff7e00', '#838d06', '#049c0b']"
        ></range-input>

        <div v-else style="border-bottom: 1px solid #D5D6D7; margin: 10px 0 10px 0"></div>

        <div style="display: flex; flex-direction: column; justify-content: space-between">
            <div class="payment-type-description text-justify p-4" v-html="method.description"></div>

            <div class="text-center p-3">
                <button v-on:click="onClick" class="btn btn-lg btn-secondary">{{ $t('Quero este') }}</button>
            </div>

            <div class="text-justify p-4" v-html="method.secondary_description"></div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    props: {
        method: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onClick() {
            this.$emit('change', this.tag)
        }
    }
})
</script>
